import Cookies from 'js-cookie'

const PublicKey = 'PublicKey'
const LoginUsersIdKey = 'LoginUsersId'
const LoginUsersTokenKey = 'LoginUsersToken'

export function getPublicKey() {
  return Cookies.get(PublicKey)
}

export function setPublicKey(token) {
  return Cookies.set(PublicKey, token)
}

export function removePublicKey() {
  return Cookies.remove(PublicKey)
}

export function getLoginUsersId() {
  return Cookies.get(LoginUsersIdKey)
}

export function setLoginUsersId(id) {
  return Cookies.set(LoginUsersIdKey, id)
}

export function removeLoginUsersId() {
  return Cookies.remove(LoginUsersIdKey)
}

export function getLoginUsersToken() {
  return Cookies.get(LoginUsersTokenKey)
}

export function setLoginUsersToken(token) {
  return Cookies.set(LoginUsersTokenKey, token)
}

export function removeLoginUsersToken() {
  return Cookies.remove(LoginUsersTokenKey)
}

export function isAuthenticated() {
  return !!getLoginUsersToken()
}



// WEBPACK FOOTER //
// ./src/utils/auth.js